import { useHistory, useLocation } from 'react-router-dom'

import AccountTreeIcon from '@mui/icons-material/AccountTree'
import CropFreeIcon from '@mui/icons-material/CropFree'
import DashboardIcon from '@mui/icons-material/Dashboard'
import EmailIcon from '@mui/icons-material/Email'
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    '&[data-mode="drawer"]': {
      background: '#fff',
    },
    '&[data-mode="sidebar"]': {
      background: '#222',
    },
  },
  item: {
    paddingRight: spacing(4),
  },
  icon: {
    padding: spacing(2, 0),
    minWidth: 40,
    '&[data-mode="sidebar"]': {
      '&[data-active="true"]': {
        color: palette.primary.light,
      },
      '&[data-active="false"]': {
        color: '#ccc',
      },
    },
    '&[data-mode="drawer"]': {
      '&[data-active="true"]': {
        color: palette.primary.main,
      },
      '&[data-active="false"]': {
        color: '#888',
      },
    },
  },
  text: {
    '&[data-mode="sidebar"]': {
      '&[data-active="true"]': {
        color: palette.primary.light,
        fontWeight: 'bold',
      },
      '&[data-active="false"]': {
        color: '#ccc',
        fontWeight: 'normal',
      },
    },
    '&[data-mode="drawer"]': {
      '&[data-active="true"]': {
        color: palette.primary.main,
        fontWeight: 'bold',
      },
      '&[data-active="false"]': {
        color: '#888',
        fontWeight: 'normal',
      },
    },
  },
}))

const menus = [
  { path: 'dashboard', label: 'ダッシュボード', icon: DashboardIcon },
  { path: 'accounts', label: 'アカウント一覧', icon: AccountTreeIcon },
  { path: 'users', label: '管理者管理', icon: SupervisorAccountIcon },
  { path: 'products', label: '商品管理', icon: CropFreeIcon },
  { path: 'templates', label: 'メールテンプレート', icon: EmailIcon },
]

export default function Menu({ onClick, drawer = false }) {
  const { push } = useHistory()
  const { pathname } = useLocation()
  const classes = useStyles()
  const mode = drawer ? 'drawer' : 'sidebar'

  const handleClick = path => {
    push(path)
    if (onClick) {
      onClick()
    }
  }

  return (
    <List className={classes.root} data-mode={mode}>
      {menus.map(x => {
        const path = `/admin/${x.path}`
        const active = pathname.startsWith(path)
        return (
          <ListItem
            key={x.path}
            button
            className={classes.item}
            onClick={() => handleClick(x.path)}
          >
            <ListItemIcon className={classes.icon} data-mode={mode} data-active={active}>
              <x.icon />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography className={classes.text} data-mode={mode} data-active={active}>
                  {x.label}
                </Typography>
              }
            />
          </ListItem>
        )
      })}
    </List>
  )
}
